<img
  [class]="'logoCss ' + classesToAdd"
  src="shared-assets/images/acengageLogo.png"
/>
